import { render, staticRenderFns } from "./PriceTab.vue?vue&type=template&id=7f48c38f"
import script from "./PriceTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports